// extracted by css-extract-rspack-plugin
var _1 = "h";
var _2 = "ez";
var _3 = "g";
var _4 = "b";
var _5 = "fl";
var _6 = "e0";
var _7 = "lj";
var _8 = "f";
export { _1 as "content", _2 as "imageLoaderComponent", _3 as "inner", _4 as "modalComponent", _5 as "text", _6 as "title", _7 as "userCommunicationModalComponent", _8 as "wrapper" }
